import { billBaseMock } from '@fixtures/apis/bill/detail-v3/bill-base'
import { BillStatus } from '@types'
import { MockFactory } from '@tino-frontend/mocks'

const billBaseEmpty = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'bill-EMPTY-0',
    status: BillStatus.Open,
    due_amount: 0,
    minimum_amount: 0,
    paid_amount: 0,
    spent_amount: 0,
    flags: {
      ...billBaseMock.source.flags,
      is_empty: true,
      is_zero: true,
    },
  },
  { mergeArray: false }
)

export const billBaseEmptyMock = new MockFactory(billBaseEmpty)
